import Roblox from 'Roblox';
import { DeepLink, DeepLinkParams, PathPart } from './deepLinkConstants';
import deepLinkNavigate from './deepLinkNavigate';
import deepLinkGameJoin from './deepLinkGameJoin';
import deepLinkFollowUserToExperience from './deepLinkFollowUserToExperience';
import ExperienceInviteStatus from './enums/ExperienceInviteStatus';
import FriendInviteStatus from './enums/FriendInviteStatus';

const firstUriSegmentToHandler: { [type: string]: (target: DeepLink) => Promise<boolean> } = {
  [PathPart.Navigation]: deepLinkNavigate,
  [PathPart.PlaceId]: deepLinkGameJoin,
  [PathPart.UserId]: deepLinkFollowUserToExperience
};

const pathRegex = /\/(\w+)/g; // matches: /(pathSegment)
const paramRegex = /(\w+)=(\w+)/g; // matches: (param)=(value)

const parseDeepLink = (deepLinkString: string): DeepLink => {
  const path: Array<PathPart> = [];
  const params: DeepLinkParams = {};

  let pathPart = pathRegex.exec(deepLinkString);
  while (pathPart) {
    path.push(pathPart[1] as PathPart);
    pathPart = pathRegex.exec(deepLinkString);
  }

  let paramPart = paramRegex.exec(deepLinkString);
  while (paramPart) {
    const key = paramPart[1];
    const value = paramPart[2];
    params[key] = value;
    paramPart = paramRegex.exec(deepLinkString);
  }

  return {
    path,
    params
  };
};

const DeepLinkService = {
  parseDeeplink: parseDeepLink,
  navigateToDeepLink: (deepLinkString: string): Promise<boolean> => {
    const target: DeepLink = parseDeepLink(deepLinkString);
    const handler = firstUriSegmentToHandler[target.path[0]];
    return handler ? handler(target) : Promise.resolve(false);
  }
};

const ShareLinks = {
  ExperienceInviteStatus,
  FriendInviteStatus
}

Object.assign(Roblox, {
  DeepLinkService,
  ShareLinks
});

export default DeepLinkService;
